import type { MarketExceptionType } from '../../MarketExceptionTypes'
import { Common } from '../Common/Common'

export const MX: MarketExceptionType = {
  ...Common,
  hasNativeCreditCard: true,
  hasStoreCredit: true,
  marketoSmsOptIn: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  isCashMarket: true,
  currencyCode: 'MXN',
  creditCardProvidersSupported: ['MC', 'VI', 'AX', 'DI'],
  hasSubscriptionSchedule: true,
  isPickupMarket: true,
  hasAddressRegion: true,
  supportsStoreCredit: true,
  applePayOTP: true,
  applePaySubscriptions: true,
  hasProductAvailability: true,
}
